export const APP_CONSTANTS = {
    FIXEDPRICE: "Servizi a Prezzo Fisso",
    HOURLYRATE: "Servizi a Ora",
    SALES: "Servizi Vendita",
    CORPORATE: "Servizio Aziendale",
    WAREHOUSESERVICE: "Servizi Magazzino",
    FIXED_PRICE_SALRY: "Servizi a Prezzo Fisso",
    HOURLY_PRICE_SALRY: "Servizi in Ora",
    WAREHOUSE_PRICE_SALRY: "Servizi Magazzino",
    MORE_THAN: "morethan",
    LESS_THAN: "lessthan",
    EQUAL: "equal",
    NOT_EQUAL: "notequal",
    MORE_THAN_OR_EQUAL: "morethanorequal",
    LESS_THAN_OR_EQUAL: "lessthanorequal",
    SALE_SERVICE_INVOICE_MODEL: 'sales',
    FIXED_SERVICE_INVOICE_MODEL: 'fixedprice',
    HOURLY_SERVICE_INVOICE_MODEL: 'hourlyrate',
    CORPORATE_SERVICE_INVOICE_MODEL: 'corporate',
    WAREHOUSE_SERVICE_INVOICE_MODEL: 'warehouseservice',
    FIXED_SERVICE_SALARY_MODEL: 'fixedpricesalary',
    HOURLY_SERVICE_SALARY_MODEL: 'hourlyratesalary',
    WAREHOUSE_SERVICE_SALARY_MODEL: 'warehousesalary',
};
  